
import FinancialAnalysisTab from "components/housingCompany/details/FinancialAnalysis/FinancialAnalysisTab";

function FinancialAnalysis(props: any) {
    const selectedTab = 2;
    return (
        <>
            <FinancialAnalysisTab props={props} selectedTab={selectedTab}/>
        </>
    );
}

export default FinancialAnalysis;